import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const baseConfig = {
  confirmButtonColor: '#f3c715',
  cancelButtonColor: '#1f2937',
  color: '#111827',
  background: '#ffffff',
};

function themedSwal(options) {
  const isDark = document.documentElement.classList.contains('dark');
  return Swal.fire({
    ...baseConfig,
    background: isDark ? '#141414' : '#ffffff',
    color: isDark ? '#f9fafb' : '#111827',
    ...options,
  });
}

export function showCreateSuccess(sectionName) {
  return themedSwal({
    icon: 'success',
    title: 'Created!',
    text: `${sectionName} has been created successfully.`,
    timer: 2200,
    showConfirmButton: false,
  });
}

export function showUpdateSuccess(sectionName) {
  return themedSwal({
    icon: 'success',
    title: 'Updated!',
    text: `${sectionName} has been updated successfully.`,
    timer: 2200,
    showConfirmButton: false,
  });
}

export function showDeleteSuccess(sectionName) {
  return themedSwal({
    icon: 'success',
    title: 'Deleted!',
    text: `${sectionName} has been deleted successfully.`,
    timer: 2200,
    showConfirmButton: false,
  });
}

export function showError(message, title = 'Action failed') {
  return themedSwal({
    icon: 'error',
    title,
    text: message,
    confirmButtonText: 'OK',
  });
}

export async function confirmDelete(sectionName) {
  const result = await themedSwal({
    icon: 'warning',
    title: 'Delete item?',
    text: `Are you sure you want to delete this ${sectionName.toLowerCase()} record?`,
    showCancelButton: true,
    confirmButtonText: 'Yes, delete',
    cancelButtonText: 'Cancel',
    reverseButtons: true,
  });

  return result.isConfirmed;
}

export async function confirmAction({ title, text, confirmButtonText = 'Confirm', icon = 'question' }) {
  const result = await themedSwal({
    icon,
    title,
    text,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText: 'Cancel',
    reverseButtons: true,
  });

  return result.isConfirmed;
}

export async function promptReason({ title, placeholder }) {
  const result = await themedSwal({
    title,
    input: 'textarea',
    inputPlaceholder: placeholder,
    inputAttributes: { maxlength: 500 },
    showCancelButton: true,
    confirmButtonText: 'Reject',
    reverseButtons: true,
    inputValidator: (value) => (!value || !value.trim() ? 'A reason is required.' : undefined),
  });

  return result.isConfirmed ? result.value.trim() : null;
}

export function showSuccess(message, title = 'Done!') {
  return themedSwal({
    icon: 'success',
    title,
    text: message,
    timer: 2200,
    showConfirmButton: false,
  });
}
